import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export function WhatsAppSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const wabaId = searchParams.get('waba_id');

  useEffect(() => {
    // Redirect to company settings after showing success message
    const timer = setTimeout(() => {
      navigate('/companySettings');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="card" style={{ maxWidth: '500px' }}>
        <div className="card-body text-center">
          <div className="mb-4">
            <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '4rem' }}></i>
          </div>

          <h4 className="card-title text-success fw-semibold mb-3">
            WhatsApp Conectado com Sucesso!
          </h4>

          {wabaId && (
            <p className="card-text text-muted fw-semibold mb-3">
              WABA ID: {wabaId}
            </p>
          )}

          <p className="card-text fw-semibold">
            Sua conta do WhatsApp Business foi integrada com sucesso.
            Você será redirecionado para as configurações da empresa em alguns segundos.
          </p>

          <div className="progress mt-4">
            <div
              className="progress-bar progress-bar-striped progress-bar-animated bg-success"
              style={{ width: '100%' }}
            ></div>
          </div>

          <button
            onClick={() => navigate('/companySettings')}
            className="btn btn-primary mt-3"
          >
            Ir para Configurações
          </button>
        </div>
      </div>
    </div>
  );
}